/* eslint-disable */
import React from "react";
import { ProfessionalBenefits } from "./partials";

export default class ProductManager extends React.Component {
  render () {
    return (
      <div className="container page-container">
        <div className="card">
          <h2 style={{ marginBottom: 20, textAlign: "center" }}>Product Manager - Denver, CO</h2>

          <h4>About Haven Connect</h4>
          <p style={{ fontSize: 15 }}>
            Haven Connect transforms the affordable housing industry by streamlining the application
            process for residents and property managers. Haven Connect uses automation and a deep
            understanding of the regulatory challenges for affordable housing to get low-income
            Americans into units faster {"&"} at a fraction of the cost.
          </p>

          <h4 style={{ marginTop: 40 }}>About You</h4>
          <p style={{ fontSize: 15 }}>
            You care deeply about both improving the lives of Americans with low income and building
            a real, profitable business. You are a prioritizing pro, obsessed with building products
            consumers love, and aren’t afraid to say no to one-off requests in the pursuit of product
            greatness.
          </p>

          <h4 style={{ marginTop: 40 }}>What you'll do</h4>
          <p style={{ fontSize: 15 }}>
            <li>Define new product features and functionality (think Zapier meets Zenefits)</li>
            <li>
              Design and test Haven Connect’s product, including step-by-step instructions for
              property managers and applicants.
            </li>
            <li>Collaborate with the engineering team to time product releases</li>
            <li>
              Identify and execute opportunities to improve existing product features using data and
              analytics.
            </li>
          </p>

          <h4 style={{ marginTop: 40 }}>Required Skills and Experience</h4>
          <p style={{ fontSize: 15 }}>
            <li>
              User Experience testing - you’ll need to be equally comfortable user testing with
              affordable housing property managers and low-income people.
            </li>
            <li>
              Systems-oriented, ability to think at both the 50,000 foot-level (how the parts make
              the whole) and the 5 foot-level (how each part works).
            </li>
            <li>
              Willing to dive deep on the regulations and prioritize features relentlessly based on
              user feedback.
            </li>
            <li>
              High attention to detail and organization; data-driven, analytical problem-solving
            </li>
            <li>Ability to take initiative and get things done with little to no direction.</li>
            <li>Past experience with Mixpanel, Keen.io, etc.</li>
            <li>5-8 years as a Product Manager previously</li>
            <li>
              Extra Credit: background with tax-credit or HUD affordable housing regulations
              (flexible on this if you're willing to learn!).
            </li>
          </p>

          <ProfessionalBenefits />

          <p style={{ fontSize: 15 }}>
            Please email resume or LinkedIn profile to{" "}
            <a href="mailto:hiring@havenconnect.com">hiring@havenconnect.com</a>
          </p>
        </div>
      </div>
    );
  }
}
